export default {
  index: [
    {
      path: '/qybzjorder',
      component: resolve => require(['./qybzjorderIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/qy_bzjorder/_router.js